import Wrap from './../wrap'

export default function Select(props) {
    const { onChange, required, value, name, readOnly, options, emptyText } = props
    const useValue = value || ''

    return (
        <Wrap {...props} type="select">
            <select onChange={onChange} required={required} value={useValue} name={name} readOnly={readOnly}>
                {(!value || emptyText) && <option value="">{emptyText || ''}</option>}
                {options.map((option, k) => (
                    <option key={`${k}-${option.value}`} value={option.value}>
                        {option.name}
                    </option>
                ))}
            </select>
        </Wrap>
    )
}
